import {createContext} from 'react';

export const PageLevelAdTargetContext = createContext({});
export const SlotLevelAdTargetContext = createContext({});
